import ProduitFormFormulesController from './produit.form.formules.controller';

export default {
    bindings: {
        produit: '='
    },
    template: require('./produit.form.formules.html'),
    controller: ProduitFormFormulesController
};
